import {Component, inject, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HotelInfoUiService } from '../accommodation-info/services/hotel-info-ui.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';

@Component({
  selector: 'iho-reviews-of-city',
  templateUrl: './reviews-of-city.component.html',
  styleUrls: ['./reviews-of-city.component.scss'],
    standalone: true,
    providers: [HotelInfoUiService],
      imports: [
          CommonModule,
           FormsModule,
           SharedModule,
      ]
})
export class ReviewsOfCityComponent implements OnInit {
  reviewsCount = 0;
     columnCount: number = 4;
    // ---
     colClass: number = 3;
  stateCities: any[] = [];
  reviewsOfCity: any[] = [];
  breadcrumb = [
    {
      Url: '/',
      Name: 'صفحه اصلی',
      AriaCurrent: false
    },
    {
      Url: '',
      Name: 'نظرات',
      AriaCurrent: false
    }
  ]
  whiteBoxData: any[] = [
    {
      iconSource: 'assets/images/5488754.png',
      title: 'با ثبت رزرو شروع میشود',
      description: 'تنها راه برای ثبت نظر این است که هتل خود را رزرو کنید. از این طریق ما مطلع می شویم، نظراتی که ثبت می شود بوسیله ی میهمانان حقیقی است و آنها در واقعیت در هتل اقامت داشته اند'
    },
    {
      iconSource: 'assets/images/1379916.png',
      title: 'با سفر ادامه پیدا میکند',
      description: 'زمانی که میهمان در هتل اقامت دارد مواردی از جمله آرامش هتل و برخورد کارکنان هتل و ... را بررسی می کند.'
    },
    {
      iconSource: 'assets/images/3039617.png',
      title: 'و در نهایت ثبت نظر',
      description: 'بعد از سفر، میهمانان از اقامتشان برای ما می گویند و ما پس از ویرایش و اطمینان از صحت و اعتبار نظرات، آنها را روی وبسایت نمایش می دهیم'
    }
  ]
  latestReviews: any[] = []
  masonryData: any[] = []
  cities: any[] = []
  filteredMasonryData = this.masonryData
  slug:any;
  route = inject(ActivatedRoute);
  constructor(private websiteService: HotelInfoUiService) {
  }

  ngOnInit(): void {
    this.slug = this.route.snapshot.paramMap.get('city');
    this.getReviewsOfCity(this.slug);
  }





  getReviewsOfCity(cityName: string) {
    this.websiteService.getRveiewsOfCity(cityName).subscribe(
      (response) => {
        this.reviewsOfCity = response.LatestReviews;
        this.breadcrumb = response.BreadCrumb;
        this.reviewsCount = response.VotesCount;
      }
    )
  }
  tolowerUrl(url: string) {
    return url.toLowerCase();
    }
   
}
